import styled from 'styled-components/macro';

export const StyledSelect = styled.div<{
  isSelected: boolean;
  isDisabled?: boolean;
}>`
  background-color: ${(props) =>
    props.isDisabled ? '#F8F9FA' : props.isSelected ? '#2D67D8' : '#F2F5F8'};
  color: ${(props) =>
    props.isDisabled ? '#697180' : props.isSelected ? '#FFFFFF' : '#1F2939'};
  font-size: 14px;
  font-weight: 400;
  padding: 8px 12px 8px 12px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) =>
      props.isDisabled ? '' : props.isSelected ? '#1D4ED6' : '#E4E8EE'};
    color: ${(props) =>
      props.isDisabled ? '' : props.isSelected ? '#FFFFFF' : '#1F2939'};
  }
`;
